export const API_ERROR_CODES = {
  200: { code: 200, message: 'OK - Request succeeded' },
  204: {
    code: 204,
    message: 'No Content - Request succeeded, but no content returned',
  },
  400: { code: 400, message: 'Bad Request - Invalid input' },
  404: {
    code: 404,
    message: 'Not Found - The requested resource does not exist',
  },
  409: {
    code: 409,
    message: 'Conflict - Request conflicts with the current state',
  },
  422: { code: 422, message: 'Unprocessable Entity - Validation failed' },
  500: {
    code: 500,
    message: 'Internal Server Error - Something went wrong on our end',
  },
  502: {
    code: 502,
    message: 'Bad Gateway - Received an invalid response from upstream',
  },
  503: {
    code: 503,
    message: 'Service Unavailable - Server is temporarily unavailable',
  },
};
